import { LanguageTranslationKeys } from 'i18n/languages/en';

import bookSlotSrc from '@common/assets/images/appointments-visual-guide/book-slot.webp';
import selectSubject from '@common/assets/images/appointments-visual-guide/select-subject.png';
import selectTeacherLyceum from '@common/assets/images/appointments-visual-guide/select-teacher-lyceum.png';
import selectTeacherSrc from '@common/assets/images/appointments-visual-guide/select-teacher.webp';
import selectWeekSrc from '@common/assets/images/appointments-visual-guide/select-week.png';
import { useServiceRouter } from '@common/components/ServiceRouter';

import { AdditionalInfoSectionType } from '../components/AdditionalInfoSection';
import { InfoSectionType } from '../components/InfoSection';
import { BbookingStepsType } from '../types';

export interface VisualGuideStepItemType {
	title: LanguageTranslationKeys;
	imageSrc: string;
	altImageName: string;
}

const STEP_LIBRARY = {
	selectSubject: {
		title: 'appointment.lyceumVisualGuide.selectSubject',
		imageSrc: selectSubject,
		altImageName: 'selectSubject',
	},
	selectTeacherLyceum: {
		title: 'appointment.lyceumVisualGuide.selectTeacher',
		imageSrc: selectTeacherLyceum,
		altImageName: 'selectTeacher',
	},
	selectTeacher: {
		title: 'appointment.visualGuide.selectTeacher',
		imageSrc: selectTeacherSrc,
		altImageName: 'selectTeacher',
	},
	selectWeekLyceum: {
		title: 'appointment.lyceumVisualGuide.selectWeek',
		imageSrc: selectWeekSrc,
		altImageName: 'selectWeek',
	},
	selectWeek: {
		title: 'appointment.visualGuide.selectWeek',
		imageSrc: selectWeekSrc,
		altImageName: 'selectWeek',
	},
	bookSlot: {
		title: 'appointment.visualGuide.bookSlot',
		imageSrc: bookSlotSrc,
		altImageName: 'bookSlot',
	},
} as const;

export const getVisualGuideSteps = (): VisualGuideStepItemType[] => {
	const { checkService } = useServiceRouter();
	const isLyceum = checkService('lyceum');

	if (isLyceum) {
		return [
			STEP_LIBRARY.selectSubject,
			STEP_LIBRARY.selectTeacherLyceum,
			STEP_LIBRARY.selectWeekLyceum,
			STEP_LIBRARY.bookSlot,
		];
	}

	return [STEP_LIBRARY.selectTeacher, STEP_LIBRARY.bookSlot, STEP_LIBRARY.selectWeek];
};

export const INFO_SECTION: InfoSectionType = {
	sectionDescription: 'appointment.visualGuide.sectionDescription',
	usefulInfo: 'appointment.visualGuide.usefulInfo',
	sessionDuration: 'appointment.visualGuide.sessionDuration',
	sessionFormat: 'appointment.visualGuide.sessionFormat',
};

export const STEP_SECTION: BbookingStepsType = {
	bookingSteps: 'appointment.visualGuide.bookingSteps',
};

export const ADDITIONAL_INFO_SECTION: AdditionalInfoSectionType = {
	note: 'appointment.visualGuide.note',
	bookingRestriction: 'appointment.visualGuide.bookingRestriction',
	sessionLinkInfo: 'appointment.visualGuide.sessionLinkInfo',
};
